import type * as BackendTypes from 'chaika-types';
import { DatesAsString, StringArrayAsString } from '../backend';

export const EhrAccessVerdict = {
    Allow: 'allow',
    Deny: 'deny',
} as const;

export type EhrAccessVerdict = (typeof EhrAccessVerdict)[keyof typeof EhrAccessVerdict];

export const EhrAccessDenyReason = {
    Blacklist: 'blacklist',
    NoGrant: 'no_grant',
} as const;

export type EhrAccessDenyReason = (typeof EhrAccessDenyReason)[keyof typeof EhrAccessDenyReason];

export interface EhrAccessDecision extends BackendTypes.EhrAccessDecision {}

export type EhrAccessHasManyResponse = Record<string, EhrAccessDecision>;

export interface EhrAccessMemberData extends DatesAsString<BackendTypes.EhrAccessMemberResponse> {}

export interface EhrAccessOwnEhrsResponse extends BackendTypes.EhrAccessOwnEhrsResponse {}

export interface EhrAccessGrantListQuery extends StringArrayAsString<
    DatesAsString<BackendTypes.EhrAccessGrantListQuery>
> {}

export interface EhrAccessBlacklistQuery extends StringArrayAsString<
    DatesAsString<BackendTypes.EhrAccessBlacklistQuery>
> {}

export interface EhrAccessPatientData extends BackendTypes.EhrAccessPatientViewModel {}

export interface EhrAccessUserData extends BackendTypes.EhrAccessUserViewModel {}

export interface EhrAccessGrantData extends DatesAsString<BackendTypes.EhrAccessGrantViewModel> {}

export interface EhrAccessGrantListResponse extends Omit<BackendTypes.EhrAccessGrantListResponse, 'grants'> {
    grants: EhrAccessGrantData[];
}

export interface EhrAccessBlacklistEntryData extends DatesAsString<BackendTypes.EhrAccessBlacklistEntryViewModel> {}

export interface EhrAccessBlacklistEntryListResponse extends Omit<
    BackendTypes.EhrAccessBlacklistEntryListResponse,
    'entries'
> {
    entries: EhrAccessBlacklistEntryData[];
}
